import React, { useState } from "react";
import { promptsData } from "../data/promptsData";
import { Copy, Check } from "lucide-react";
import "../styles/aiTools.css";

export default function AIToolsPrompts() {
  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  return (
    <div className="prompts-section">
      <div className="prompts-header-desc">
        <h2>Unlock Ultimate Productivity 🚀</h2>
        <p>Browse copy-and-paste prompts guaranteed to optimize results from popular models.</p>
      </div>

      <div className="prompts-grid">
        {promptsData.map((recipe) => (
          <div key={recipe.id} className="prompt-card">
            <div className="prompt-card-top">
              <span className="prompt-cat-badge">{recipe.category}</span>
            </div>
            <h3>{recipe.title}</h3>
            <p className="prompt-desc">{recipe.description}</p>
            
            <div className="prompt-box">
              <pre>{recipe.prompt}</pre>
              <button 
                className="copy-prompt-btn" 
                onClick={() => handleCopy(recipe.prompt, recipe.id)}
              >
                {copiedId === recipe.id ? <Check size={16} color="#10b981" /> : <Copy size={16} />}
                {copiedId === recipe.id ? "Copied!" : "Copy Prompt"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
